import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import { SCROLL } from '@/constants/custom-event-names';
import { userAction } from '@/util/helpers/ajax-helpers';
import {
  BOTTOM,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  DISMISS_ONBOARDING,
  LEFT,
  RIGHT,
  TOP,
} from './HighlightFeature';
import css from '../css/module/onboarding.css';
import flex from '../css/module/flex.css';

class DisplayHighlightFeature extends Component {
  state = {
    pos: null,
    loading: true,
  };

  componentDidMount() {
    this.updateWithTimeout();
    window.addEventListener(SCROLL, this.updatePos);
  }

  updateWithTimeout() {
    // the default timeout here > the time it takes for the sidebars to slide open and closed. It makes the appearance of the onboarding elements less abrupt.
    const { delay = 1000 } = this.props;

    this.timer = setTimeout(() => {
      this.setState({
        loading: false,
      });
      this.updatePos();
    }, delay);
  }

  componentDidUpdate(prevProps) {
    const { modalIsOpen } = this.props;

    if (modalIsOpen) {
      if (!prevProps.modalIsOpen && modalIsOpen) {
        this.setState({
          loading: true,
        });
      }
      if (prevProps.modalIsOpen && !modalIsOpen) {
        this.setState({
          loading: false,
        });
        this.updatePos();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener(SCROLL, this.updatePos);
    clearTimeout(this.timer);
  }

  updatePos = () => {
    const { element } = this.props;
    const pos = element.getBoundingClientRect();
    const newPos = {
      top: pos.top,
      bottom: pos.bottom,
      right: pos.right,
      left: pos.left,
    };
    this.setState({
      pos: newPos,
    });
  };

  contentBuilder = () => {
    const {
      text,
      targetAction,
      position,
      title,
      style = {},
      hideButton,
    } = this.props;

    const logDismissAction = (e) => {
      e.stopPropagation();
      // target action can be an array. If the user clicks the "got it" button, fire a "dismissed" action just using the first item, as this is still clear.
      const dimissAction = Array.isArray(targetAction)
        ? DISMISS_ONBOARDING + targetAction[0]
        : DISMISS_ONBOARDING + targetAction;

      userAction(dimissAction);
    };

    const bodyStyle = {};

    if (!hideButton && targetAction) {
      bodyStyle.borderBottomLeftRadius = '0px';
      bodyStyle.borderBottomRightRadius = '0px';
    }

    const content = (
      <div className={`${css.arrow_box} ${css.fadeIn}`} style={style}>
        {title ? (
          <div className={flex.flex}>
            <span className={css.title}>{title}</span>
          </div>
        ) : null}
        <div
          style={bodyStyle}
          className={`${css.body} ${
            hideButton && ![LEFT].includes(position) ? 'text-align-center' : ''
          }`}
        >
          {text}
        </div>
        {hideButton || !targetAction ? null : (
          <div className={css.footer}>
            <Button variant="secondary" onClick={logDismissAction}>
              Got it
            </Button>
          </div>
        )}
      </div>
    );

    return this.container(content);
  };

  container = (content) => {
    const { position } = this.props;

    const style = {
      position: 'absolute',
      zIndex: 12,
      width: '1px',
      height: '1px',
      display: 'flex',
      overflow: 'visible',
    };

    let parentClass = css.top;

    if (
      position === BOTTOM ||
      position === BOTTOM_LEFT ||
      position === BOTTOM_RIGHT
    ) {
      style.top = `${this.state.pos.top + 15}px`;
    }

    switch (position) {
      case BOTTOM: {
        parentClass = css.bottom;
        style.left = `${(this.state.pos.right + this.state.pos.left) / 2}px`;
        style.justifyContent = 'center';
        break;
      }
      case BOTTOM_LEFT: {
        parentClass = `${css.bottom} ${css.bottomLeft}`;
        style.left = `${this.state.pos.right}px`;
        style.justifyContent = 'flex-end';
        break;
      }
      case BOTTOM_RIGHT: {
        parentClass = `${css.bottom} ${css.bottomRight}`;
        style.left = `${this.state.pos.left}px`;
        style.justifyContent = 'flex-start';
        break;
      }
      case TOP: {
        parentClass = css.top;
        style.top = `${this.state.pos.bottom - 15}px`;
        style.left = `${(this.state.pos.right + this.state.pos.left) / 2}px`;
        style.justifyContent = 'center';
        style.alignItems = 'flex-end';
        break;
      }
      case RIGHT: {
        parentClass = css.right;
        style.top = `${(this.state.pos.top + this.state.pos.bottom) / 2}px`;
        style.left = `${this.state.pos.left + 15}px`;
        style.alignItems = 'center';
        break;
      }
      case LEFT: {
        parentClass = css.left;
        style.top = `${(this.state.pos.top + this.state.pos.bottom) / 2}px`;
        style.left = `${this.state.pos.right - 15}px`;
        style.alignItems = 'center';
        style.justifyContent = 'flex-end';
        break;
      }
    }

    return (
      <div className={`position-absolute ${parentClass}`} style={style}>
        {content}
      </div>
    );
  };

  render() {
    if (this.state.loading || !this.state.pos) {
      return null;
    }

    return this.contentBuilder();
  }
}

export default DisplayHighlightFeature;
